import { render, staticRenderFns } from "./TwoSizesRangeStep.vue?vue&type=template&id=04331a2a&scoped=true&"
import script from "./TwoSizesRangeStep.vue?vue&type=script&lang=js&"
export * from "./TwoSizesRangeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04331a2a",
  null
  
)

export default component.exports